import { sendEventToAnalytics } from '@lib/helpers/client'

export default function massApplyButtonClickEvent(): void {
  const eventName = 'web_apply_to_all_button_clicked'
  const payload = {}
  sendEventToAnalytics(eventName, payload)
}
